import moment from 'moment-timezone';
import { useEffect, useState } from 'react';

type Props = {
  format?: string;
};

export default function useCurrentTime(props: Props = { format: 'ddd, DD MMMM HH:mm' }) {
  const { format } = props;

  const [time, setTime] = useState(moment());

  useEffect(() => {
    const interval = setInterval(() => setTime(moment()), 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    time,
    formattedTime: time.format(format),
  };
}
